import { uuidv4 } from '../../util/tools';
import { WebSocketEventData } from '../custom-event/types';
import { GatewayWebSocketService } from '../web-socket/GatewayWebSocket.service';
import { GatewayRequestType, GatewayResponseType } from '../web-socket/types';

import { BaseSubscriptionRequestType } from './types';

export abstract class BaseSubscriptionService<T extends BaseSubscriptionRequestType> {
  protected readonly gatewayService: GatewayWebSocketService;

  protected subscripitonRequests: T[] = [];

  protected constructor() {
    this.gatewayService = GatewayWebSocketService.getInstance();
    this.registerResponseHandler();
  }

  protected unsubscribeResponseHandler?: () => void;

  protected registerResponseHandler(): void {
    this.unsubscribeResponseHandler = this.gatewayService.subscribeToResponses(
      this.getResponseType(),
      event => this.handleResponseEvent(event),
      event => this.shouldHandleResponse(event),
    );
  }

  private destroy(): void {
    if (this.unsubscribeResponseHandler) {
      this.unsubscribeResponseHandler();
      this.unsubscribeResponseHandler = undefined;
    }
  }

  public static resetInstance(): void {
    // Access the static instance on the subclass
    const self = this as any;
    if (self.instance) {
      self.instance.destroy();
      self.instance = undefined;
    }
  }

  protected abstract handleResponseEvent(event: WebSocketEventData<any>): void;

  protected abstract subscribe(item: string, ...args: any[]): void;

  protected abstract subscribeList(item: string[], ...args: any[]): void;

  protected abstract unsubscribe(item: string, ...args: any[]): void;

  protected abstract unsubscribeList(item: string[], ...args: any[]): void;

  protected abstract getSubscriptionRequestType(): GatewayRequestType;

  protected abstract getUnsubscriptionRequestType(): GatewayRequestType;

  protected abstract getResponseType(): GatewayResponseType;

  protected shouldHandleResponse(event: WebSocketEventData<any>): boolean {
    return true;
  }

  protected getDefaultRequestParams(): BaseSubscriptionRequestType {
    return {
      messageType: this.getSubscriptionRequestType(),
      traceIdentifier: uuidv4(),
    };
  }

  protected sendRequestToGw(request: T): void {
    this.subscripitonRequests.push(request);
    this.gatewayService.sendRequest(request);
  }
}
